$ = jQuery;

/*
Functions
*/

var currentWindowSize = $(window).width();

function checkDefiniteResize() {
    var definiteResize = false;
    if (currentWindowSize !== $(window).width()) {
        definiteResize = true;
    }

    currentWindowSize = $(window).width();
    return definiteResize;
}

function getWindowWidth() {

    var bodyOverflowX = $('body').css('overflow-x');
    var bodyOverflowY = $('body').css('overflow-y');
    $('body').css('overflow', 'hidden');
    var windowWidth = $(window).width();
    $('body').css({
        'overflowX': bodyOverflowX,
        'overflowY': bodyOverflowY
    });

    return windowWidth;
}

function positionAdvancedPageListing() {

    // - This is now done through CSS using the translate(0, -50%) hack
    // Space out the page listing text
    /*$('.linked-pages-listing-adv > .inner .page-holder > .inner > .foreground').each(function(){

    	$(this).css('padding', '');
    	if($(this).outerHeight() < $(this).parent().height()){

    		$(this).css({
    			'padding': (($(this).parent().height() - $(this).height()) / 2) + 'px 0 0 0'
    		});
    	}
    });*/
}

function positionPageListing() {

    // Space out the page listing titles and text
    $('.linked-pages-listing > .inner .page-holder .title-holder > .inner').each(function() {
        $(this).css({
            'padding-top': ($(this).parent().height() - $(this).height()) / 2
        });
    });

    $('.linked-pages-listing > .inner .page-holder .text-holder > .inner').each(function() {
        $(this).css({
            'padding-top': ($(this).parent().height() - $(this).height()) / 2
        });
    });
}

function positionQuickLinks() {

    // Space out the quick link titles
    $('.quick-links > .inner .quick-link > .inner > .title').each(function() {
        $(this).css({
            'padding-top': ($(this).parent().height() - $(this).height()) / 2
        });
    });
}

function getNext(_subject) {
  if(_subject.next().length > 0) { return _subject.next(); }
  return getNext(_subject.parent());
}

function searchFor(_selector, _subject) {
  if(_subject.is(_selector)) {return _subject;}
  else {
      var found = null;
      _subject.children().each(function() {
          found = searchFor(_selector, $(this));
          if(found != null) {return false;}
      });
      return found;
  }
  /* eslint-disable */
  return null; // will/should never get here
  /* eslint-enable */
}

function nextInDOM(_selector, _subject) {
  var next = getNext(_subject);
  while(next.length !== 0) {
      var found = searchFor(_selector, next);
      if(found != null) {return found;}
      next = getNext(next);
  }
  return null;
}

function setPaddings() {
  /* eslint-disable */
  
  //var container = $('header .bottom > .container').width();
  //console.log(container);
  //var win = $(window).width();
  //var padding = (win - container) / 2;
  /* eslint-enable */
//console.log('win: ' + win);
//console.log('padding: ' + padding);
  
  //$('.empty-place .before').css({
  //  'left':-padding,
  //  'width':win,
  //});

}


function matchHeight(windowWidth, holders, resizeClasses, callback) {

    $(holders).each(function() {

        var holder = $(this);
        var resize = [];

        $.each(resizeClasses, function(i, val) {
            // Create an array of the elements that are to be resized
            resizeSingle = [];
            resizeSingle[0] = val;
            resizeSingle[1] = 0;
            resize[i] = resizeSingle;
        });

        $.each(resize, function(i) {
            holder.find(resize[i][0]).css('height', 'auto');
        });

        if (windowWidth > holder.attr('data-min-width')) {
            holder.children('.row').each(function() {

                var rowElement = $(this);
                var indexes = [];
                var clearfixEnd = false;

                $.each(resize, function(i) {
                    resize[i][1] = 0;
                });

                rowElement.children().each(function() {

                    var childElement = $(this);

                    if (childElement.is(':visible')) {

                        if (childElement.hasClass('clearfix')) {

                            $.each(indexes, function(i, val) {
                                $.each(resize, function(i2) {
                                    rowElement.children().eq(val).find(resize[i2][0]).height(resize[i2][1]);
                                });
                            });

                            indexes = [];
                            clearfixEnd = true;

                            $.each(resize, function(i) {
                                resize[i][1] = 0;
                            });

                        } else {
                            indexes.push($(this).index());
                            clearfixEnd = false;

                            $.each(resize, function(i) {
                                if (childElement.find(resize[i][0]).height() > resize[i][1]) {
                                    resize[i][1] = childElement.find(resize[i][0]).height();
                                }
                            });
                        }
                    }

                });

                if (!clearfixEnd) {
                    $.each(indexes, function(i, val) {
                        $.each(resize, function(i2) {
                            rowElement.children().eq(val).find(resize[i2][0]).height(resize[i2][1]);
                        });
                    });
                }
            });
        }
    });

    if (callback !== false) {
        callback();
    }

    $(holders).css('opacity', 1);
}

function matchHeights() {

    // Match the heights of certain element's child elements, once they have been resized change the opacity to 1 (the elements should initially be hidden through CSS)
    matchHeight(getWindowWidth(), '.swatch-listing > .inner', ['.text-holder > .swatch-pages', '.text-holder > h5', '.text-holder > .reference'], false);
    matchHeight(getWindowWidth(), '.linked-pages-listing > .inner', ['.title-holder', '.text-holder'], positionPageListing);
    matchHeight(getWindowWidth(), '.linked-pages-listing-adv > .inner', ['a.inner'], positionAdvancedPageListing);
    matchHeight(getWindowWidth(), '.quick-links > .inner', ['a.inner'], positionQuickLinks);
}

function getUrlParameters() {

    var vars = {},
        hash;

    var q = document.URL.split('?')[1];

    if (q != undefined) {
        q = q.split('&');
        for (var i = 0; i < q.length; i++) {
            hash = q[i].split('=');
            vars[hash[0]] = hash[1];
        }
    }

    return vars;
}

function initSelectmenu(){
	// Change certain select elements via jquery ui selectmenu
	$('select.custom-select').selectmenu({
		icons: { button: "icon-icon-chevron" }
	});

	$( ".selector" ).selectmenu( "refresh" );

	// Trigger the select change event for certain custom selects
	$('.swatch-archive-template .price-filter-holder select,.search-results .price-filter-holder select,.configuration-holder .product-additional-option-groups .product-option-choices.style-select select,.configuration-holder .pre-measurement-option-holder select').on( "selectmenuchange", function( event, ui ) {
        $(this).trigger('change');
    });
}

function refreshSelectmenu() {
    $('select.custom-select').selectmenu('refresh');
}

function createOverlay(type, extra_data) {

    var overlay = $('<div><div class="indicator"></div><div class="solar-overlay-inner"></div></div>').attr('class', 'solar-overlay loading').height($(document).height());
    $('body').append(overlay);

    var data = {
        'action': 'populate_overlay',
        'nonce': nonce_string,
        'type': type
    };

    if (extra_data) {
        $.extend(data, extra_data);
    }

    $.post(ajaxurl, data, function(response) {

        if (response) {

            var overlay_inner = overlay.find('> .solar-overlay-inner');
            overlay_inner.html(response);

            setTimeout(function() {
                overlay_inner.css({
                    'top': ((overlay_inner.innerHeight() + 20) >= $(window).height() ? 20 : (($(window).height() - overlay_inner.innerHeight()) / 2)),
                    'left': ((overlay_inner.innerWidth() + 20) >= $(window).width() ? 20 : (($(window).width() - overlay_inner.innerWidth()) / 2)),
                    'max-height': $(window).height() - 40,
                    'max-width': $(window).width() - 40
                });

                overlay.removeClass('loading');
                overlay_inner.addClass('shown');

                // Specific events for the overlay
                // - convert measurements
                overlay.find('form[name=convert_measurements]').submit(function() {

                    var width_mm = Math.round($(this).find('input[name=convert_measurements_width]').val() / 0.039370);
                    var drop_mm = Math.round($(this).find('input[name=convert_measurements_drop]').val() / 0.039370);

                    $('.measurement-holder .measurement-inputs input[name=measurement_width]').val(width_mm);
                    $('.measurement-holder .measurement-inputs input[name=measurement_drop]').val(drop_mm).trigger('change');

                    overlay.remove();

                    return false;
                });

                // - close the overlay
                overlay.click(function(e) {
                    if ($(e.target).hasClass('solar-overlay')) {
                        overlay.remove()
                    }
                });

            }, 100);

        } else {
            overlay.remove();
        }
    }).fail(function() {
        overlay.remove();
    });
}

function QuoteBreakdown() {
    var _positionTimer = null;

    var _position = function(setHeight) {
        // Move the quote breakdown depending on the screen size
        if (getWindowWidth() > 991) {
            $('.mobile-quote-breakdown-holder > .quote-breakdown-holder-inner').appendTo($('.quote-breakdown-holder'));
            $('.quote-breakdown-holder-inner .quote-options-holder').css('max-height', 'none');
        } else {
            $('.quote-breakdown-holder > .quote-breakdown-holder-inner').appendTo($('.mobile-quote-breakdown-holder'));
            $('.quote-breakdown-holder-inner .quote-breakdown').css('width', '100%').removeClass('fixed fixed-bottom');
            $('.quote-breakdown-holder').css('height', 'auto');

            // Make sure the options list height doesnt exceed the page height
            $('.quote-breakdown-holder-inner .quote-options-holder').css('max-height', $(window).height());

        }

        if ($('.quote-breakdown-holder > .quote-breakdown-holder-inner').length) {

            if (setHeight) {

                $('.quote-breakdown-holder').css('height', 'auto');
                if (getWindowWidth() > 991) {
                    $('.quote-breakdown-holder').height($('.quote-breakdown-holder').parent().height());
                }
            }

            $('.quote-breakdown-holder .quote-breakdown').width($('.quote-breakdown-holder > .quote-breakdown-holder-inner')[0].getBoundingClientRect().width);

            // Make the swatch quick quote holder fixed after a certain point (only if the quote holder is smaller than the left hand content)
            if (getWindowWidth() > 991 && $(window).scrollTop() >= ($('.quote-breakdown-holder').offset().top - 20) && $('.quote-breakdown-holder .quote-breakdown').height() < $('.quote-breakdown-holder').siblings().height()) {

                $('.quote-breakdown-holder .quote-breakdown').addClass('fixed');

                if ($('.quote-breakdown-holder').height() >= (($(window).scrollTop() - ($('.quote-breakdown-holder').offset().top - 20)) + $('.quote-breakdown-holder .quote-breakdown').height())) {
                    $('.quote-breakdown-holder .quote-breakdown').removeClass('fixed-bottom');
                } else {
                    $('.quote-breakdown-holder .quote-breakdown').addClass('fixed-bottom');
                }

            } else {
                $('.quote-breakdown-holder .quote-breakdown').removeClass('fixed fixed-bottom');
            }
        }
    };

    this.position = function(setHeight) {
        if (_positionTimer) clearTimeout(_positionTimer);

        _positionTimer = setTimeout(function() {
            _position(setHeight);
            _positionTimer = null;
        }, 100);
    };

    return this;
}


var quoteBreakdown = new QuoteBreakdown();


function onReadyResponsive(initial, windowWidth, definiteResize) {

    if ($('#banners').length) {

        $('#banners .banner').each(function() {

            var pager_size = 0;
            if ($(this).parents('#banners').find('.owl-dots:not(.disabled)').length) {
                var pager = $(this).parents('#banners').find('.owl-dots');
                pager_size = pager.height() + parseInt(pager.css('bottom'), 10);
            }

            $(this).find('.foreground').css({
                'padding-top': ((($(this).height() - $(this).find('.foreground').height() - $('header .main-menu-holder').height() - pager_size) / 2) + $('header .main-menu-holder').height()) + 'px'
            });
		});
	} else {
		$('body > .wrap').css({
			'margin-top': $('header .main-menu-holder').height()
		});
	}

    // Position the featured section text
    if ($('.featured-section .foreground').length) {

        $('.featured-section .foreground > .inner').css('padding', '');

        if ($('.featured-section .foreground > .inner').outerHeight() < parseInt($('.featured-section').css('min-height'), 10)) {

            $('.featured-section .foreground > .inner').css({
                'padding': (($('.featured-section').height() - $('.featured-section .foreground > .inner').height()) / 2) + 'px 0 0 0'
            });
        }
    }

    // Remove the bottom margin from last items in grids
    $('.remove-last-margin').each(function() {

        var row = $(this);
        row.find('> div:not(.clearfix)').css('margin-bottom', '');

        var grid = false;
        row.find('> div:not(.clearfix)').each(function() {
            if ($(this).outerWidth(false) != row.width()) {
                grid = true;
            }
        });

        var elements;

        if (grid) {

            if (!row.find('> .clearfix:visible').last().nextAll('div:not(.clearfix)').length) {

                if ($(this).find('> .clearfix:visible').last().prevAll('.clearfix:visible').length) {
                    elements = row.find('> .clearfix:visible').last().prevAll('.clearfix:visible').first().nextAll('div:not(.clearfix)');
                } else {
                    elements = row.find('> div:not(.clearfix)');
                }

            } else {
                // If there are elements after the last visible clearfix then remove their bottom margins
                elements = row.find('> .clearfix:visible').last().nextAll('div:not(.clearfix)');
            }
        } else {
            // If any of the items are full width then only remove the bottom margin from the last one as we are not in a grid
            elements = row.find('> div:not(.clearfix)').last();
        }

        elements.css('margin-bottom', 0);
    });

    if (initial || definiteResize) {

        var gallery = $('#bottom-gallery');

        // Set the initial height of the bottom gallery (needs to be set in order for the animation to work out a height change)
        gallery.height(0);

        // Change the amount of images shown within the mini gallery dependant on screen size
        var per_page = 8;

        if (windowWidth <= 767) {
            per_page = 4;
        }

        gallery.attr('data-per-page', per_page);

        var data = {
            'action': 'reload_bottom_gallery',
            'nonce': nonce_string,
            'page': 1,
            'post_id': gallery.attr('data-post-id'),
            'per_page': gallery.attr('data-per-page')
        };

        $.post(ajaxurl, data, function(response) {
            gallery.html(response);

            var image_height = ($(window).width() / (per_page / 2)) * (360 / 480);
            var gallery_height = image_height * Math.round(gallery.find('.image-holder').length / (per_page / 2));
            gallery.height(gallery_height);

            // Offset the bottom gallery pager
            gallery.find('.gallery-pager').css({
                'margin-left': '-' + (gallery.find('.gallery-pager').width() / 2) + 'px'
            }).addClass('shown');
        });
    }
}

function moveGroupBannerText() {
    var $group_banner_text = $('#group-banner-text');
    $('#group-banner-text.cloned').remove();
    if( $group_banner_text.length > 0 ) {
        var $group_banner_text_clone = $group_banner_text.clone();
        $group_banner_text_clone.addClass('cloned');
        $group_banner_text.remove();
        var $container = $('.main');
        $container.append($group_banner_text_clone);
    }
}

function onLoadResponsive(initial, windowWidth, definiteResize) {

    // Space out the main menu items equally
    var menu_width = $('header .main-menu-holder .menu').width();
    var num_items = $('header .main-menu-holder .menu > li').length;

    var total_items_width = 0;
    $('header .main-menu-holder .menu > li').each(function() {
        total_items_width += $(this).width();
    });

    // Space out the items depending on a certain width, otherwise they will look too spaced out
    if (num_items > 1 && menu_width - total_items_width < 650) {

        // Work out the specific margin to be added to each side of the items (minus 1 from the num items to take into account the first and last items that will be flush against the container)
        var margin = Math.floor(((menu_width - total_items_width) / (num_items - 1)) / 2) - 1;

        $('header .main-menu-holder .menu > li').css({
            'margin-right': margin + 'px',
            'margin-left': margin + 'px'
        });

        $('header .main-menu-holder .menu > li:first-of-type').css({
            'margin-left': 0
        });
        $('header .main-menu-holder .menu > li:last-of-type').css({
            'margin-right': 0
        });
    } else {
        $('header .main-menu-holder .menu > li').css({
            'margin-right': '',
            'margin-left': ''
        });
    }

    matchHeights();
    quoteBreakdown.position(true);
}

/*
jQuery events
*/

$(document).ready(function() {
    var logo = $("#logo");

    function MakeLogoWhite() {
        logo.addClass("white-logo");
        logo.removeClass("black-logo");

        logo.attr("src", logo.data("white"));
    }

    function MakeLogoBlack() {
        logo.addClass("black-logo");
        logo.removeClass("white-logo");

        logo.attr("src", logo.data("black"));
    }

    function SetLogo() {
        var has_banner = $("body").hasClass("has-banner");
        var nav_open = $(".toggle-mobile-main-menu").hasClass("active");

        // console.log(logo.data("white"));
        // console.log(logo.data("black"));

        // console.log(has_banner);
        // console.log(nav_open);

        if (has_banner) {
            MakeLogoWhite();
        }
        else {
            MakeLogoBlack();

            if (nav_open) {
                MakeLogoWhite();
            }
            else {
                MakeLogoBlack();
            }
        }
    }

    SetLogo();

    // Fire custom trigger to Google Tag Manager wheh the contact email is clicked
    $('#contact-email').click(function() {
        window[gtm4wp_datalayer_name].push({
            'event': 'gtm4wp.contactEmailClicked'
        });
    });

    // Add a mirrored png fallback option for any images with the addFallback class
    $('img.addFallback').each(function() {
        var fallbackUrl = $(this).attr('src').slice(0, -3) + 'png';
        $(this).attr('data-fallback', fallbackUrl);
    });

    // If SVG is not supported then change the src to the set png fallback
    if (!Modernizr.svg) {
        $('img[data-fallback]').each(function() {
            $(this).attr("src", $(this).data('fallback'));
        });
    }

    // Re-arrange the main menu sub items neatly into 4 columns
    $('header .main-menu-holder .menu .sub-menu').each(function() {

        var sub_menu = $(this);
        var total_items = sub_menu.find('li').length;
        var items_per_col_base = Math.floor(total_items / 4);

        sub_menu.wrapInner('<div class="row inner"></div>');

        for (var i = 1; i <= 4; i++) {
            var items_per_col = items_per_col_base + (i <= (((total_items / 4) - items_per_col_base) * 4) ? 1 : 0);
            sub_menu.find('> .inner > li:lt(' + items_per_col + ')').wrapAll('<div class="col-sm-3"><div class="inner"></div></div>');
        }

    });

    // Toggle mobile menu
    $('header .mobile-main-menu-holder .menu > li.current-menu-item, header .mobile-main-menu-holder .menu > li.current-menu-ancestor').each(function() {
        $(this).find('> .inner > .toggle').addClass('active');
        $(this).find('> ul').show();
    });
    $('header .mobile-main-menu-holder .menu > li > .inner > .toggle').click(function() {
        $(this).toggleClass('active');
        $(this).parents('li').find('> ul').slideToggle();
    });

    // Initialise the owl carousel
    $('#banners').owlCarousel({
        items: 1,
        loop: true,
        nav: true,
        navText: '',
        autoplay: $('.page-template-template-home').length ? 4000 : false
    });

    $('.configuration-holder > .inner > .top .images-holder > .inner').owlCarousel({
        items: 1,
        loop: true,
        nav: true,
        navText: '',
        animateOut: 'fadeOut',

    });

    lightbox.option({
        'showImageNumberLabel': false
    });


    // Change the bottom banner on pagintion click
    $(document).on('click', '#bottom-gallery .gallery-pager > .inner > div', function() {

        var gallery = $(this).parents('#bottom-gallery');
        var new_index = $(this).index();

        if (!$(this).hasClass('active') && !gallery.find('.gallery-images').hasClass('animating')) {
            gallery.find('.gallery-images').addClass('animating');

            var data = {
                'action': 'reload_bottom_gallery_images',
                'nonce': nonce_string,
                'page': new_index + 1,
                'post_id': gallery.attr('data-post-id'),
                'per_page': gallery.attr('data-per-page')
            };

            $.post(ajaxurl, data, function(response) {
                gallery.find('.gallery-pager > .inner > div:eq(' + new_index + ')').addClass('active').siblings().removeClass('active');

                var $temp = $('<div>').html(response);
                var number_rows = Math.ceil($temp.find('.image-holder').length / (gallery.attr('data-per-page') / 2));
                var old_height = gallery.height();
                var new_height = gallery.find('.gallery-images > .image-holder').height() * number_rows;

                if (new_height != old_height) {
                    gallery.height(new_height);
                }
                gallery.find('.gallery-images').html(response);

                gallery.find('.gallery-images > .image-holder').addClass('stagger-image');
                gallery.find('.gallery-images > .image-holder').each(function() {

                    var image = $(this);

                    setTimeout(function() {
                        image.removeClass('stagger-image');
                    }, 50 * image.index());

                });
            }).always(function() {
                gallery.find('.gallery-images').removeClass('animating');
            });
        }

    });

    $('.linked-pages-listing-adv > .inner .page-holder > .inner').hover(function() {

        if (getWindowWidth() > 991) {
            $(this).find('.foreground > .inner .text').slideToggle();
            matchHeights();
        }
    });

    // Configure the url paramters on swatch listing sort order change
    $('.swatch-archive-template .price-filter-holder select, .search-results .price-filter-holder select').change(function() {

        var select = $(this);

        var link = document.URL.split('?')[0];
        var vars = getUrlParameters();
        var seperator = '?';

        $.each(vars, function(index, val) {
            if (index != select.attr('name')) {
                link += seperator + index + '=' + val;
                seperator = '&';
            }
        });

        link += seperator + select.attr('name') + '=' + select.val();

        // Re-load the page with the new parameters
        window.location.href = link;
    });

    // Create the measurements converter overlay
    $(document).on('click', '.convert-measurements > a', function() {
        createOverlay('measurements_converter', false);
        return false;
    });

    // Swatch quote price calculations

    /*

    ----- Notes -----

    ? - hash all the option choices with their appropraite option ids in a hidden form element to be sent over to the 'cart' page, un hash it on the cart and work out the total price
    ? - add in extra checks
    	- swatch-id could be changed
    	- product-data-id could be changed

    */

    // Pre measurement option
    $('.configuration-holder .pre-measurement-option-holder select').change(function() {

        var option_holder = $(this).parents('.product-option');

        // Clear all configuration options (this is due to some of them not being available for the new size)
        $('.configuration-holder .product-additional-option-groups').remove();
        $('.configuration-holder .measurement-holder > div').remove();

        update_product_configuration('pre-measurements', option_holder, $(this).val());
    });

    // Width/drop

    var measurement_input_selector = '.configuration-holder .measurement-holder .measurement-inputs input';

    $(document).on('change', measurement_input_selector, function() {

        var option_holder = $(this).parents('.product-option');

        var width = $(this).parents('.measurement-inputs').find('input[name=measurement_width]').val();
        var drop = $(this).parents('.measurement-inputs').find('input[name=measurement_drop]').val();

        // Only get a price if both measurement values are entered
        if (width != '' && drop != '') {

            // Clear all configuration options (this is due to some of them not being available for the new size)
            $('.configuration-holder .product-additional-option-groups').remove();

            update_product_configuration('measurements', option_holder, false);
        }
    });

    // Calculate the price immediately as the smallest dimensions will be set on load
    if ( $( measurement_input_selector ).length ) {
        var $measurement_input_option_holder = $( measurement_input_selector ).parents('.product-option');
        update_product_configuration('measurements', $measurement_input_option_holder, false);
    }

    // Other options
    // - Grid style choices
    $(document).on('click', '.configuration-holder .product-additional-option-groups .product-option-choices.style-grid .product-option-choice > .inner > *', function() {

        var option_holder = $(this).parents('.product-option');
        var choice_holder = $(this).parents('.product-option-choice');

        update_product_configuration('option_grid', option_holder, (choice_holder.hasClass('active') ? '' : option_holder.find('.product-option-choice').index(choice_holder)));
    });
    // - Select style choices
    $(document).on('change', '.configuration-holder .product-additional-option-groups .product-option-choices.style-select select', function() {
        var option_holder = $(this).parents('.product-option');
        var choice_holder = $(this).find('option:selected');

        update_product_configuration('option_select', option_holder, choice_holder.val());
    });

    // Create a global variable to store the dynamic configuration data
    var configuration_data = '';

    function update_product_configuration(type, option_holder, option_choice) {

        option_holder.find('> .alert').remove();

        $('.product-option').addClass('loading');
        option_holder.addClass('loading-main');

        var option_id = option_holder.attr('data-option-id');

        var data = {
            'action': 'update_product_configuration',
            'nonce': nonce_string,
            'listing_id': $('.single-swatch-template').attr('data-listing-id'),
            'swatch_id': $('.single-swatch-template').attr('data-swatch-id'),
            'product_data_id': $('.single-swatch-template').attr('data-product-data-id'),
            'option_id': option_id,
            'choice': option_choice,
            'configuration_data': configuration_data,
            'type': type
        };

        // console.log(data);

        if (type != 'pre-measurements') {
            data['measurements'] = {
                'width': $('.configuration-holder .measurement-holder .measurement-inputs input[name=measurement_width]').val(),
                'drop': $('.configuration-holder .measurement-holder .measurement-inputs input[name=measurement_drop]').val()
            };
        }

        $.post(ajaxurl, data, function(response) {

            if (response.error) {
                option_holder.prepend('<div class="alert alert-danger" role="alert">' + response.error + '</div>');
            } else {

                // Assign the new configuration data to the global js variable to be used in the next ajax call
                configuration_data = response.configuration_data;

                // Update the quick quote option list
                if (response.quick_quote_items_html)
                    $('.quote-breakdown-holder-inner .quote-options-holder .options-list').html(response.quick_quote_items_html);

                if (type == 'pre-measurements') {

                    if (response.configuration_html)
                        $('.configuration-holder .measurement-holder').html(response.configuration_html);

                    // Assign the correct product band id, this will be used later on in the
                    $('.single-swatch-template').attr('data-product-data-id', response.product_data_id);

                } else {

                    // Update the configuration options list
                    if (response.configuration_html) {

                        // First check whether any options are yet shown, if not then create the holder
                        if (!$('.configuration-holder > .inner > .product-additional-option-groups').length)
                            $('.configuration-holder > .inner').append('<div class="product-additional-option-groups"></div>');

                        $('.configuration-holder > .inner > .product-additional-option-groups').html(response.configuration_html);

                        initSelectmenu();
                    }
                }

                // Update the total price
                $('.quote-breakdown-holder-inner .quote-price-holder .price').text('£' + response.total_price);
                $('.quote-breakdown-holder-inner .quote-options-holder .price-holder .price').text('£' + response.total_price);

                quoteBreakdown.position(true);
                moveGroupBannerText();
            }

        }).always(function() {
            $('.product-option').removeClass('loading');
            option_holder.removeClass('loading-main');
        });
    }

    // Create the option full description overlay
    $(document).on('click', '.product-option .toggle-full-description', function() {

        var data = {
            'option_id': $(this).parents('.product-option').attr('data-option-id')
        };

        createOverlay('option_description', data);
    });

    // Replace the CF7 '---' value for a default select option
    $('select.wpcf7-select option').each(function() {
        if ($(this).text() == '---') {
            $(this).text('Select from list');
        }
    });

    initSelectmenu();

    // Create custom checkboxes
    $('.create-custom-checkbox').each(function() {
        if ($(this).find('input[type=checkbox]').length) {
            $(this).addClass('custom-checkbox');

            if ($(this).find('input[type=checkbox]').prop('checked')) {
                $(this).addClass('checked');
            }
        }
    });

    $('.custom-checkbox').click(function(e) {
        e.preventDefault();
        var check = $(this).find('input[type=checkbox]').prop('checked') ? false : true;
        $(this).find('input[type=checkbox]').prop('checked', check);
        $(this).toggleClass('checked');
    });

    // Toggle the mobile main menu
    $('.toggle-mobile-main-menu').click(function() {
        $(this).toggleClass('active');
        $('.mobile-main-menu-holder').fadeToggle();
        $('header').toggleClass('show');

        SetLogo();
    });

    // Toggle the mobile sidebar filters
    $('.toggle-mobile-sidebar-filters').click(function() {
        $(this).toggleClass('active');
        $('#sidebar-filters-holder .sidebar-filters').slideToggle();
    });

    // Toggle the mobile quote breakdown
    $(document).on('click', '.mobile-quote-breakdown-holder .toggle-mobile-quote-breakdown', function() {
        $(this).toggleClass('active');
        $('.mobile-quote-breakdown-holder .quote-breakdown-holder-inner .quote-options-holder .options-list').slideToggle();
    });

    onReadyResponsive(true, getWindowWidth(), true);

    $('.member-item').click(function(){
      var nextEmpty = nextInDOM('.empty-place.desktop .content',$(this));
      var nextEmpty2 = nextInDOM('.empty-place.tablet .content',$(this));
      var nextEmpty3 = nextInDOM('.empty-place.mobile .content',$(this));
      $('.empty-place .member-content').remove();
      //$('.empty-place').hide();
      $('.member-item').css('opacity',1);

      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $('.empty-place .member-content').hide();
      } else {
        $(this).siblings().removeClass('active');
        $('.member-item').not(this).css('opacity',0.4);
        $(this).addClass('active');
        var content1 = $(this).find('.member-content').clone();
        var content2 = $(this).find('.member-content').clone();
        var content3 = $(this).find('.member-content').clone();
        nextEmpty.prepend(content1);
        nextEmpty.show('fast');
        nextEmpty2.prepend(content2);
        nextEmpty2.show('fast');
        nextEmpty3.prepend(content3);
        nextEmpty3.show('fast');
      }
    });

    setPaddings();    

    $(window).resize(function(){
      setPaddings();
    });

    // Booking form
    // Allow selecting time
    function AllowTime() {
        $(".gform_body .time input").each(function() {
            this.disabled = false;
        });
    }

    // Disallow selecting time
    function SetReadOnly() {
        $(".gform_body .datepicker").attr('readonly', 'readonly');
    }

    // Disallow selecting time
    function DisallowTime() {
        $(".gform_body .time input").each(function() {
            this.disabled = true;
            this.checked = false;
        });
    }

    // Allow date selected
    function AllowDate() {
        $(".gform_body .datepicker").each(function() {
            $(this).prop('disabled', false);
        });
    }

    // Disallow selecting time
    function DisallowDate() {
        $(".gform_body .datepicker").each(function() {
            $(this).prop('disabled', true);
        });
    }

    // Prevent typing within the date picker
    SetReadOnly();

    // Initially disallow selecting time
    DisallowTime();
    
    // Array that contains dates to disable when calendar is shown
    var timesAndDates = {};
    var dateFormat = null;
    // Prepopulate depending on how many times
    function CleanTimesAndDates() {
        timesAndDates = {};
        $(".gform_body .time input").each(function(index, item) {
            var val = $(item).val();
            if (!timesAndDates[val]) {
                timesAndDates[val] = [];
            }
        });
    }
    CleanTimesAndDates();

    // Checks using timesAndDates array to see if a date is available
    function CheckDateAvailable(date) {

        var isInTime = {};
        $(".gform_body .time input").each(function(index, item) {
            var val = $(item).val();
            if (!isInTime[val]) {
                isInTime[val] = false;
            }
        });

        for (var key in timesAndDates) {
            if (timesAndDates.hasOwnProperty(key)) {
                if ($.inArray(date, timesAndDates[key]) != -1) {
                    if (isInTime.hasOwnProperty(key)) {
                        isInTime[key] = true;
                    }
                }
            }
        }

        var count = 0;
        for (var key in isInTime) {
            if (isInTime[key]) {
                count++;
            }
        }

        return count < Object.keys(isInTime).length;
    }

    // Updates calendar with ajax
    function UpdateCalendar() {
        $.ajax({
            type: "POST",
            url: ajaxurl,
            data: {
                action: 'booking_form_get_entries'
            },
            beforeSend: function() {
                // Disable selecting date on calendar and time
                DisallowTime();
                DisallowDate();
                // CleanTimesAndDates();

                $('#gform_1').addClass('loading');
            },
            success: function (output) {
                var appointments = output.data;

                appointments.forEach(function(item, index) {
                    // Check if both time slots are occupied
                    var time = item[10];
                    timesAndDates[ item.time ].push( String( $.datepicker.formatDate( dateFormat, new Date( item.date ) ) ) );
                });

                $('#gform_1').removeClass('loading');
            },
            complete: function() {
                AllowDate();
            }
        });
    }

    if ( typeof( gform ) !== "undefined") {
        UpdateCalendar();

        // Update Calendar when Showroom appointment
        $(".gform_body .appointment-type input, .gform_body .showroom select").on("change", function() {
            // Call ajax to update form
            UpdateCalendar();
        });

        $(".gform_body .time input").on("change", function() {
            // Call ajax to update form
            // UpdateCalendar();
        });

        gform.addFilter( 'gform_datepicker_options_pre_init', function( optionsObj, formId, fieldId ) {
            // do stuff
            // optionsObj.dateFormat = 'd MM yy';
            dateFormat = optionsObj.dateFormat;

            // Only allow dates 2 days in to the future
            optionsObj.minDate = new Date();
            optionsObj.minDate.setDate(optionsObj.minDate.getDate() + 2);

            optionsObj.onSelect = function(datetext) {
                // When date is changed call ajax to update form
                UpdateCalendar();

                // Find times available for selected date
                
                $(".gform_body .time input").each(function(index, item) {
                    var val = $(item).val();
                    
                    this.disabled = $.inArray(datetext, timesAndDates[val]) != -1;
                });
            }

            // Available week days
            optionsObj.beforeShowDay = function(date) {
                // Every day
                var dayOkay = date.getDay() >= 0 && date.getDay() <= 6;

                // Ensure that the date is okay to be used
                var formatted_date = String($.datepicker.formatDate(dateFormat, date));

                // Check if date is in all time slots
                var dateOkay = CheckDateAvailable(formatted_date);

                return [dayOkay && dateOkay, ""];
            }

            // optionsObj.disabled = true;
            return optionsObj;
        });
    }

    // Home page group partners slider
    if ($('.home-swiper').length > 0) {
        const homeSwiper = new Swiper('.home-swiper', {
            slidesPerView: 1,
            spaceBetween: 15,
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                },
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 70,
                }
            },
        });
    }

    // Footer logos
    if ($('.footer-logos').length > 0) {
        const footerSwiper = new Swiper('.footer-swiper', {
            slidesPerView: 3,
            spaceBetween: 15,
            breakpoints: {
                768: {
                    slidesPerView: 5,
                    spaceBetween: 60,
                },
                1200: {
                    slidesPerView: 6,
                    spaceBetween: 120,
                },
            },
        })
    }

    // Themes
    if ($('#theme').length > 0) {
        if ($('#theme').val() == 'solar') {
            $('.orange-text').each(function() {
                $(this).removeClass('orange-text');
                $(this).addClass('solar-text');
            });

            $('.btn-default').each(function() {
                $(this).addClass('btn-solar');
            });

            $('.btn-primary').each(function() {
                $(this).addClass('btn-solar');
            });

            $('.menu-btn').each(function() {
                $(this).find('a').addClass('btn-solar');
            });

            $('a').each(function() {
                if (!$(this).hasClass('btn') && !$(this).parent().hasClass('.menu-item')) {
                    $(this).addClass('a-solar');
                }
            });
        }
    }
});

$(window).load(function() {

    onLoadResponsive(true, getWindowWidth(), true);

    $('.initialHidden').css('opacity', 1);

});

$(window).resize(function() {

    var definiteResize = checkDefiniteResize();
    var windowWidth = getWindowWidth();

    onLoadResponsive(false, windowWidth, definiteResize);
    onReadyResponsive(false, windowWidth, definiteResize);

    if (definiteResize) {

        // Refresh the selectmenus (this will make sure the widths are always correct)
        refreshSelectmenu();

        // Remove any overlays
        $('.solar-overlay').remove();

        // Reset the sidebar filter
        $('.toggle-mobile-sidebar-filters').removeClass('active');
        if (windowWidth > 991) {
            $('#sidebar-filters-holder .sidebar-filters').show();
        } else {
            $('#sidebar-filters-holder .sidebar-filters').hide();
        }

        // Reset the quick quote holder
        $('.mobile-quote-breakdown-holder .toggle-mobile-quote-breakdown').removeClass('active');
        if (windowWidth > 991) {
            $('.quote-breakdown-holder-inner .quote-options-holder .options-list').show();
        } else {
            $('.quote-breakdown-holder-inner .quote-options-holder .options-list').hide();
        }
    }
});

$(window).scroll(function() {
    quoteBreakdown.position(false);
});

function Sidebar() {
    var _origHeader = null;
    var _sidebar = null;
    var _sidebarHeader = null;
    var _menuItems = null;
    var _isResponsive = false;

    this.getSidebar = function() {
        if (!_sidebar) _sidebar = $('aside.sidebar');
        return _sidebar;
    }

    this.hasSidebar = function() {
        return this.getSidebar().length > 0;
    }

    this.getSidebarHeader = function() {
        if (!_sidebarHeader) _sidebarHeader = this.getSidebar().find('.style-1 ul.menu > li > a');
        return _sidebarHeader;
    }

    this.getMenuItems = function() {
        if (!_menuItems) _menuItems = this.getSidebar().find('ul.sub-menu');
        return _menuItems;
    }

    this.isActive = function() {
        return this.getSidebarHeader().hasClass('active');
    }

    this.layout = function() {
        if (this.hasSidebar()) {
            var sidebar = this.getSidebar();
            var sidebarHeader = this.getSidebarHeader();
            var menuItems = this.getMenuItems();

            if ($(window).width() <= 991) {
                if (!_origHeader) _origHeader = $(sidebarHeader).text();
                $(sidebarHeader).text('Menu');

                if (!_isResponsive) $(menuItems).hide();
                _isResponsive = true;
            } else {
                if (_origHeader) $(sidebarHeader).text(_origHeader);
                $(menuItems).show();
                this.getSidebarHeader().removeClass('active');
                _isResponsive = false;
            }

            $(sidebarHeader).css('display', 'block');
        }
    };

    // Setup click handlers
    if (this.hasSidebar()) {
        var that = this;
        this.getSidebarHeader().click(function(e) {
            if ($(window).width() <= 991) {
                $(this).toggleClass('active');
                if (that.isActive()) {
                    $(that.getMenuItems()).slideDown();
                } else {
                    $(that.getMenuItems()).slideUp();
                }
                e.preventDefault();
            }
        });
    }

    return this;
}

var sidebar = null;

$(window).resize(function() {
	sidebar.layout();
	teamTopResponsive();
});

$(document).ready(function() {
	sidebar = new Sidebar();
	sidebar.layout();
});


/*
*  new_map
*
*  This function will render a Google Map onto the selected jQuery element
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	$el (jQuery element)
*  @return	n/a
*/

function new_map( $el ) {
	
	// var
	var $markers = $el.find('.marker');

	// vars
	var args = {
		zoom		: 16,
		center		: new google.maps.LatLng(0, 0),
		mapTypeId	: google.maps.MapTypeId.ROADMAP,
		scrollwheel : false,
  		zoomControl : true,
  		fullscreenControl: false,
  		mapTypeControl: false,
  		streetViewControl: false,
		styles      : [
		    {
		        "featureType": "all",
		        "elementType": "all",
		        "stylers": [
		            {
		                "hue": "#ffaa00"
		            },
		            {
		                "saturation": "-33"
		            },
		            {
		                "lightness": "10"
		            }
		        ]
		    },
		    {
		        "featureType": "road.highway",
		        "elementType": "geometry",
		        "stylers": [
		            {
		                "visibility": "simplified"
		            }
		        ]
		    },
		    {
		        "featureType": "road.highway",
		        "elementType": "labels.text",
		        "stylers": [
		            {
		                "visibility": "on"
		            }
		        ]
		    }
		]
	};
	
	// create map	        	
	var map = new google.maps.Map( $el[0], args);
	
	
	// add a markers reference
	map.markers = [];
	
	
	// add markers
	$markers.each(function(){
		
    	add_marker( $(this), map );
		
	});
	
	
	// center map
	center_map( map );

	
	// initialise directions search
	searchMap( map );

    $('#start-directions').on('keyup', function() {
        if( $( this ).val().length > 0 ) {
            $('#start-submit').removeAttr('disabled');
        } else {
            $('#start-submit').attr('disabled', 'disabled');
        }
    });

	// return
	return map;
	
}

/*
*	calculateAndDisplayRoute
*
*	Google Maps Directions API
*
*	@type 	function
*	@date 	10/04/2018
*	
*/

function calculateAndDisplayRoute(directionsService, directionsDisplay) {
	directionsService.route({
		origin: document.getElementById('start-directions').value,
		destination: $('#directions-location').find(':selected').attr('data-coordinates'),
		travelMode: 'DRIVING'
	}, function(response, status) {
		if (status === 'OK') {
		  directionsDisplay.setDirections(response);
		} else {
		  window.alert('Directions request failed due to ' + status);
		}
	});
}

/*
*	search_map
*
*	This function performs search on the Google Maps, utlising Google's Map API
*
*	@type 	function
*	@date 	10/04/2018
*	
*/

function searchMap( map ) {
	//Create our address/postcode search box here utilising Google Searchbox - link to our textbox.
    var input = document.getElementById('start-directions');
    var options = {componentRestrictions: {country: 'uk'}};
    var searchBox = new google.maps.places.SearchBox(input, options);

    //Initialise Google Maps Directions API.
    var directionsService = new google.maps.DirectionsService;
    var directionsDisplay = new google.maps.DirectionsRenderer;

	directionsDisplay.setMap(map);
	//Prevent regular submit behaviour on form, then call Google Maps API. 
	document.getElementById('get-directions-form').addEventListener('submit', function(e) {
		e.preventDefault();
		calculateAndDisplayRoute(directionsService, directionsDisplay);
	});
}

/*
*  add_marker
*
*  This function will add a marker to the selected Google Map
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	$marker (jQuery element)
*  @param	map (Google Map object)
*  @return	n/a
*/

function add_marker( $marker, map ) {

	// var
	var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

	// create marker
	var marker = new google.maps.Marker({
		position	: latlng,
		map			: map
	});

	// add to array
	map.markers.push( marker );

	// if marker contains HTML, add it to an infoWindow
	if( $marker.html() )
	{
		// create info window
		var infowindow = new google.maps.InfoWindow({
			content		: $marker.html()
		});

		// show info window when marker is clicked
		google.maps.event.addListener(marker, 'click', function() {

			infowindow.open( map, marker );

		});
	}

}

/*
*  center_map
*
*  This function will center the map, showing all markers attached to this map
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	map (Google Map object)
*  @return	n/a
*/

function center_map( map ) {

	// vars
	var bounds = new google.maps.LatLngBounds();

	// loop through all markers and create bounds
	$.each( map.markers, function( i, marker ){

		var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

		bounds.extend( latlng );

	});

	// only 1 marker?
	if( map.markers.length == 1 )
	{
		// set center of map
	    map.setCenter( bounds.getCenter() );
	    map.setZoom( 16 );
	}
	else
	{
		// fit to bounds
		map.fitBounds( bounds );
	}

}

/*
*  document ready
*
*  This function will render each map when the document is ready (page has loaded)
*
*  @type	function
*  @date	8/11/2013
*  @since	5.0.0
*
*  @param	n/a
*  @return	n/a
*/
// global var
var map = null;
var player;
var playerInfo = {
    start: 0,
    end: 100,
    offset: {
        width: 200,
        height: 200
    },
}

$(document).ready(function(){
	$('.acf-map').each(function(){
		// create map
		map = new_map( $(this) );
	});
	
    // Youtube Script
    
    var tag = document.createElement("script");
    var firstScriptTag = document.getElementsByTagName("script")[0];
    tag.src = "https://www.youtube.com/iframe_api";
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

	displayTeamMemberContent();
	teamTopResponsive();
    $('#banners-holder.video-holder').fadeIn('slow');
    
    // Find out more text scroll to .additional-content
    // Scrolls to first .additional-content class
    // ? Could possibly change .additional-content to # id instead??
    $('a').each(function() {
        var goto = $(this).data("goto");
        if (goto) {
            $(this).on("click", function() {
                $('html, body').animate({
                    scrollTop: ($(goto).first().offset().top)
                }, 500);
            });
        }
    });
});

/*
*	displayTeamMemberContent
*
*	This function shows/hides the team member's content. 
*
*	@type 	function
*	@date 	13/04/2018
*	
*/

function displayTeamMemberContent() {

	//Define content togglers here. 
	$toggleContent = $('.member-image, .full-name');
	$closeContent = $('.close-this');

	//If content toggler is clicked:
	$toggleContent.on("click", function(){ 
		
      if(!$(this).parents('.member').hasClass('inactive') && !$(this).parents('.member').hasClass('active')){
      	var member_number = $(this).parents('.member').attr('data-number');
    	var content = $('.team-members').find('.member-content[data-number="' + member_number + '"]');        

        $(this).parents('.member').addClass('active');
        $(this).parents('.member').siblings('.member').addClass('inactive');
       	$(this).parents('.member').siblings('.clearfix').html(content);
       	
       	if ($('.clearfix.hidden-xs').css('display') === "block") {
       		var dataClearfixNumber = $(this).parents('.member').siblings('.clearfix').find(".member-content").attr('data-clearfix-lg');
       		$(this).parents('.member').siblings('.clearfix.set-' + dataClearfixNumber).find(".member-content").fadeIn();
       	} else {
       		var dataClearfixNumber = $(this).parents('.member').siblings('.clearfix').find(".member-content").attr('data-clearfix-sm');
       		$(this).parents('.member').siblings('.clearfix.set-' + dataClearfixNumber).find(".member-content").fadeIn();
       	}
      }
    });

	$closeContent.on("click", function(){
		var member = $(this).parent();
		member.appendTo(member.parent().parent()).fadeOut();
		$(this).parents('.team-members').find('.member').removeClass('active');
        $(this).parents('.team-members').find('.member').siblings('.member').removeClass('inactive');
        $('.clearfix').empty();
	});

}

function teamTopResponsive(){
	var imageHeight = $('.member-image').height();
	$('.member').find('.top').height(imageHeight);
}

$(document).on('click', '[data-toggle="lightbox"]', function(event) {
    event.preventDefault();
    $(this).ekkoLightbox();
});

function onYouTubePlayerAPIReady() {
    var hasVideoHolder = $("#ytplayer")[0];

    if (hasVideoHolder) {
        var youtubeId = jQuery(".video-background").data("youtubeId");
        console.log('Youtube ID is: ' + youtubeId);
    
        player = new YT.Player("ytplayer", {
        videoId: youtubeId,
        playerVars: {
            // 'playsinline': 1,
            'autoplay': 1,
            'origin':document.domain,
            'controls': 0, // Hides the player controls
            'autohide': 1,
            'enablejsapi': 1,
            'hl': 'pt-br',
            'start': playerInfo.start,
            'end': playerInfo.end,
            // 'wmode': 'opaque',
            'loop': 1,
            'disablekb': 1,
            'fs': 0,
            'modestbranding': 1,
            'showinfo': 0,
            'rel': 0, // Disable related videos
            // 'playlist': youtubeId // You need 'playlist' to use loop
            'iv_load_policy': 3
        },
        events: {
            'onReady': onPlayerReady,
            'onStateChange': onPlayerStateChange
        }
        });
    }
}

function onPlayerReady(event) {
	player.mute();
}

function onPlayerStateChange(event) {
    if (event.data === YT.PlayerState.ENDED){
		player.playVideo();
	}
}

function ytResize() {
	var w = $('#banners-holder').width() + playerInfo.offset.width;
    var h = $('#banners-holder').height() + playerInfo.offset.height;
    
  	if (w / h > 16 / 9) {
    	player.setSize(w, w / 16 * 9);
  	} else {
    	player.setSize(h / 9 * 16, h);
  	}
}

$(window).on('load resize', function() {
    var hasVideoHolder = $("#ytplayer")[0];

    if (hasVideoHolder) {
        ytResize();
    }
});